import { useEffect, useMemo } from 'react';
import { useWindowDimensions, View } from 'react-native-web';

import useDiscoverStore, { DiscoverActions } from '../../../../zustand-stores/DiscoverStore';
import { MainTabEnum } from '../../../../shared/discover-tabs-enum';
import { ToggleButtons } from '../../../../components';
import { startCase } from '../../../../shared/string-manipulations';
import { useUrlParams } from '../../../../hooks';

import getResultsListWidth from '../../utilities/getResultsListWidth';
import { globalMargin } from '../../../../shared-components/global-styles';

const options = Object.values(MainTabEnum).map(tab => ({
  label: startCase(tab),
  value: tab,
}));

const { updateMainView } = DiscoverActions;

const MainTabBar = () => {
  const view = useDiscoverStore(store => store.view);

  const { urlParams, updateUrlParams } = useUrlParams();

  const { view: urlView } = urlParams;

  useEffect(() => {
    if (!urlView) updateUrlParams({ view });
  }, [view, urlView, updateUrlParams]);

  const layout = useWindowDimensions();
  const stylesMemo = useMemo(
    () => [getResultsListWidth(layout), { marginBottom: globalMargin }],
    [layout]
  );

  const selectView = tabValue => {
    updateUrlParams({
      view: tabValue,
      // Remove any view-specific filters
      programTypes: undefined,
    });
    updateMainView(tabValue);
  };

  return (
    <View style={stylesMemo}>
      <ToggleButtons rounded options={options} optionsSelected={[view]} onChange={selectView} />
    </View>
  );
};

export default MainTabBar;
